import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { initFirebase } from './firebase';

// Firebase config depends on which project the backend (service account) is bound
// to, so we fetch + initialize before rendering the app that uses `auth`.
initFirebase().finally(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
});
